<template>
  <div class="operate-faile-wrapper">
    <div class="fail">
      <div class="Success_title">余额不足
        <p @click="exitFail">x</p>
      </div>
      <div class="Success_content">
        <div>
          <span>开始交易时间:</span>
          <span>立即生效</span>
        </div>
        <div>
          <span>总操盘资金:</span>
          <span>{{allmoney}}</span>
        </div>
        <div>
          <span>投资本金:</span>
          <span>{{principal}}</span>
        </div>
        <div>
          <span>融资金额:</span>
          <span>0.00</span>
        </div>
        <div>
          <span>亏损警戒线:</span>
          <span>{{warning}}</span>
        </div>
        <div>
          <span>亏损平仓线:</span>
          <span>{{close}}</span>
        </div>
        <div>
          <span>账户管理费:</span>
          <span>{{fee}}</span>
        </div>
        <div>
          <span>操盘周期:</span>
          <span>自动延期</span>
        </div>
      </div>
      <div class="Success_des">
        支付本金
        <span style="color: #fe1413;">{{principal}}</span>元+管理费
        <span style="color: #fe1413;">{{fee}}</span>元,共
        <span style="color: #fe1413;">{{paymoney}}</span>元。
      </div>
      <div class="Success_description">
        <span style="color: #fe1413;">温馨提示:</span>您的账户余额只剩
        <span style="color: #fe1413;">{{balance}}</span>元，本次支付还差
        <span style="color: #fe1413;">{{lack}}</span>元
      </div>
      <div class="Success_foots">
        <a @click="goCharge">马上充值</a>
        <a @click="exitFail">返回修改</a>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Operatefaile",
  data() {
    return {};
  },
  props: {
    allmoney: "",
    principal: "",
    warning: "",
    close: "",
    fee: "",
    paymoney: "",
    balance: "",
    lack: ""
  },
  mounted: function() {},
  methods: {
    exitFail() {
      $(".operate-faile-wrapper").fadeOut(100);
    },
    goCharge() {
      let that = this;
      $(".operate-faile-wrapper").fadeOut(100);
      that.$router.push({
        path: "/myaccount/rechange"
      });
    }
  }
};
</script>
<style scoped>
.operate-faile-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}
.operateSuccess,
.fail {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 440px;
  height: 520px;
  border-radius: 5px;
  background-color: white;
  text-align: center;
}
.fail {
  width: 460px;
  height: 550px;
}
.Success_title {
  height: 50px;
  line-height: 50px;
  text-align: left;
  background-color: #fbf7f8;
  padding: 0 40px;
  font-weight: 600;
  font-size: 20px;
  position: relative;
}
.Success_content {
  overflow: hidden;
}
.Success_content div {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #ddd;
  overflow: hidden;
  margin: 0 40px;
}
.Success_content div span:nth-child(1) {
  color: #777;
  float: left;
  font-weight: 600;
}
.Success_content div span:nth-child(2) {
  color: #fe1413;
  float: right;
  font-weight: 600;
}
.Success_des {
  width: 400px;
  margin: 0 auto;
  color: #777;
  font-weight: 600;
  text-align: left;
  line-height: 25px;
}
.Success_description {
  width: 400px;
  margin: 0 auto;
  /*line-height: 40px;*/
  color: #777;
  font-weight: 600;
  text-align: left;
}
.Success_foot {
  width: 100%;
}
.Success_foot button {
  width: 220px;
  height: 40px;
  background-color: #2f8ded;
  margin: 20px 0;
  color: white;
  cursor: pointer;
}
.Success_foots a {
  display: inline-block;
  line-height: 40px;
  font-size: 14px;
  width: 100px;
  height: 40px;
  background-color: #2f8ded;
  margin: 20px 10px;
  color: white;
  box-sizing: border-box;
}
.Success_foots a:nth-child(2) {
  width: 100px;
  height: 40px;
  background-color: #f1f1f1;
  /*margin: 20px 10px;*/
  color: #101010;
  border: 1px solid #ddd;
}
.instead {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
}
.Success_title > p {
  font-size: 35px;
  line-height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  text-align: center;
  cursor: pointer;
  font-weight: 100;
}
</style>





// WEBPACK FOOTER //
// src/components/module/operatefail.vue